import { Button, CircularProgress, Typography } from '@mui/material';
import { DownloadIcon } from '../../assets/svg/Download';

export const ExportCsvButton = ({ onClick, disabled, isLoading, text }) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    startIcon={
      isLoading ? (
        <CircularProgress size={20} style={{ marginRight: '12px' }} />
      ) : (
        <DownloadIcon />
      )
    }
    sx={{
      width: 'fit-content',
      whiteSpace: 'nowrap',
      px: '16px',
      py: '8px',
      backgroundColor: '#F5F5F5',
      color: '#000',
      justifyContent: 'center',
      '@media (min-width:900px)': {
        justifyContent: 'flex-end',
      },
    }}
  >
    <Typography fontSize={16} fontWeight={500}>
      {isLoading ? 'Export in progress' : text}
    </Typography>
  </Button>
);
